import React from 'react'
import { Route } from 'react-router-dom'
import { AuthMain, Login, Logout } from '../pages/Auth'

function AuthRoutes() {
  return (
    <Route path="auth" element={<AuthMain />}>
        <Route path="login" element={<Login />}/>
        <Route path="logout" element={<Logout />}/>
    </Route>
  )
}

export default AuthRoutes;